/**
 * 
 * @param skuInfoMap 原始数据
 * @param skuMap 合并数据
 * @returns 
 */
const getSkuInventory = (skuInfoMap: any, skuMap: any) => {
  
  const tempInfoMap = {};
  Object.keys( skuInfoMap ).forEach( i => {
    const _skuId = skuInfoMap[i].skuId || skuInfoMap[i].id;
     // -1 为无限库存，统一兼容处理
     const skuItem = skuMap[_skuId];
     if (skuItem) {
       skuItem.inventoryCount = skuItem?.inventoryCount > -1 ? skuItem?.inventoryCount : 99999;
        tempInfoMap[i] = {
           skuId: _skuId,
           ...skuInfoMap[i],
           ...skuMap[_skuId],
        }
        tempInfoMap[i].price = tempInfoMap[i].promotionPrice || tempInfoMap[i].price;
        delete tempInfoMap[i].number;
        delete tempInfoMap[i].quantity;
     }
  } )
  return tempInfoMap;
}

export default getSkuInventory;